const issueReasonsValues = {
  manual: 'manual',
  other: 'other',
}
export const issueReasons = [
  {
    value: issueReasonsValues.manual,
    label: 'Reembolso emitido manualmente por otro medio',
  },
  {
    value: issueReasonsValues.other,
    label: 'Otro',
  },
]
